import { render, staticRenderFns } from "./Column_management.vue?vue&type=template&id=c18b10a8"
import script from "./Column_management.vue?vue&type=script&lang=js"
export * from "./Column_management.vue?vue&type=script&lang=js"
import style0 from "./Column_management.vue?vue&type=style&index=0&id=c18b10a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports